<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (area of systemLogAreas$ | async; track trackBy(area)) {
      <lcs-option [value]="area" id="lcs-option-id-{{ area.areaId }}">
         {{ area.name | addSpaces }}
      </lcs-option>
      }
   </div>
</ng-template>
